import { Countries } from "@physical-address/core/shared/country";
import { z } from "zod";

export const countryCodes = z.enum(
  Object.keys(Countries) as [
    keyof typeof Countries,
    ...Array<keyof typeof Countries>,
  ],
);
